module.exports = __webpack_public_path__ + "img/h08-min.3c15f329.png";